import { Field } from 'redux-form'
import Label from './Label'
import { AddRequiredValidation } from '../'

export const renderTextInputField = ({
  input,
  isRequired,
  isSearchBox = false,
  autocomplete = 'on',
  maxlength,
  placeholder,
  disabled,
  label,
  ariaLabel,
  meta,
  loadingError,
  labelStyle = {},
  inputStyle = {},
  formGroupStyle = {},
}) => {
  let errored =
    ((meta?.touched || meta?.submitFailed || (input.value && !meta?.touched && !meta?.active)) &&
      Boolean(meta?.error)) ||
    Boolean(loadingError)
  let errorId = `errMessage-${input.name}`

  return (
    <div
      className={`form-group ${errored ? 'has-error' : ''}`}
      style={{ ...formGroupStyle, ...{ opacity: disabled ? '.5' : '1' } }}
    >
      {label ? (
        <Label htmlFor={input.name} isRequired={isRequired} label={label} style={labelStyle} />
      ) : null}
      <div className={`cb-input-state${isSearchBox ? ' input-group' : ''}`} style={inputStyle}>
        {isSearchBox ? (
          <span className="input-group-addon">
            <i className="cb-glyph cb-search" data-alt="Search" />
          </span>
        ) : null}
        <input
          {...input}
          id={input.name}
          name={input.name}
          type={input.type}
          placeholder={placeholder || `Enter ${label.toLowerCase()}`}
          className="form-control"
          maxLength={maxlength}
          aria-label={label || ariaLabel}
          aria-required={isRequired}
          aria-invalid={errored}
          aria-describedby={errored ? errorId : null}
          disabled={disabled}
          autoComplete={autocomplete}
          // onFocus={(e) => {
          //   e.target.select()
          //   input.onFocus()
          // }}
        />
        {errored ? <i className="cb-glyph cb-x-mark" aria-hidden={true} /> : null}
      </div>
      {errored ? (
        <p tabIndex="-1" id={errorId} className="cb-error-msg" role="alert">
          {loadingError || meta?.error}
        </p>
      ) : null}
    </div>
  )
}

//store empty strings as nulls for backend...
export default props => (
  <Field
    {...props}
    component={renderTextInputField}
    validate={AddRequiredValidation(props.isRequired, props.validate)}
    normalize={val => (val === '' ? null : props.normalize ? props.normalize(val) : val)}
  />
)
